<template>
  <div class="mensagens-programadas-page">
    <MensagensProgramadasTable
      :translations="translations"
    />
    <!-- MensagensProgramadasWizard is centralized in ModalManager.vue and opened via eventBus -->
  </div>
</template>

<script setup lang="ts">
import { onMounted, provide } from 'vue';
import MensagensProgramadasTable from './MensagensProgramadasTable.vue';
import { log } from '@/utils/DebugLogger';

interface Props {
  translations?: Record<string, unknown>;
}

const props = withDefaults(defineProps<Props>(), {
  translations: () => ({})
});

// Provide translations to child components
provide('translations', props.translations);

onMounted(() => {
  log('MensagensProgramadasPage', 'onMounted', 'Component mounted');
});
</script>

<style scoped>
.mensagens-programadas-page {
  padding: 0;
}
</style>
